export const typeValues = ['pending', 'loading', 'progress', 'success', 'error'];